import React from 'react';
import PropTypes from 'prop-types';
import { Content, Wrapper, Item, NonInteractiveItem } from './styled/Results';
import { Input } from '../OPL/Input/Input';

class AutoCompleteInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputRef: null,
    };

    this.onInputRef = this.onInputRef.bind(this);
  }

  onInputRef(node) {
    this.setState({ inputRef: node });
  }

  render() {
    const { inputRef } = this.state;

    const {
      className,
      errors,
      results,
      isLoading,
      onQueryChange,
      onChange,
      openUp,
      value,
      renderLabel,
      disabled,
      ...inputProps
    } = this.props;

    const hasResults = results && results.length > 0;
    const hasErrors = errors && errors.length > 0;

    return (
      <Wrapper className={className}>
        <Input
          {...inputProps}
          value={value}
          onChange={onQueryChange}
          ref={this.onInputRef}
          disabled={isLoading || disabled}
        />

        {isLoading && (
          <Content openUp={openUp} width={inputRef && inputRef.getBoundingClientRect().width}>
            <Item size="small">Loading</Item>
          </Content>
        )}

        {!isLoading && (hasResults || hasErrors) && (
          <Content openUp={openUp} width={inputRef && inputRef.getBoundingClientRect().width}>
            {hasErrors && errors.map(error => <NonInteractiveItem>{error}</NonInteractiveItem>)}

            {hasResults &&
              results.map(result => (
                <Item key={result.value} onClick={() => onChange(result)}>
                  {renderLabel(result)}
                </Item>
              ))}
          </Content>
        )}
      </Wrapper>
    );
  }
}

AutoCompleteInput.defaultProps = {
  className: '',
  errors: [],
  results: [],
  isLoading: false,
  onQueryChange: () => {},
  onChange: () => {},
  openUp: false,
  value: '',
  renderLabel: result => result.label,
  disabled: false,
};

AutoCompleteInput.propTypes = {
  className: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  results: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  isLoading: PropTypes.bool,
  onQueryChange: PropTypes.func,
  onChange: PropTypes.func,
  openUp: PropTypes.bool,
  value: PropTypes.string,
  renderLabel: PropTypes.func,
  disabled: PropTypes.bool,
};

AutoCompleteInput.SearchInput = Input;

export default AutoCompleteInput;
